var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.8064 1.2251H4.06287C2.85131 1.2251 1.86914 2.20726 1.86914 3.41883V16.5812C1.86914 17.7928 2.85131 18.7749 4.06287 18.7749H23.8064C25.018 18.7749 26.0002 17.7928 26.0002 16.5812V3.41883C26.0002 2.20726 25.018 1.2251 23.8064 1.2251Z",
    stroke: "#2A2E3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.86914 7.80615H26.0002",
    stroke: "#2A2E3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.2b651adaada531cffb23192b6f616ca0.svg";
export { ForwardRef as ReactComponent };